import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../css/ModalToken.css';
import { enviarSmsToken, verificarToken } from "../../Services/sms.services";

const ModalToken = ({
  show,
  onClose,
  celular,
  correo,
  operadorId,
  onTokenValidado,
}) => {

  const [codigo, setCodigo] = useState(["", "", "", ""]);
  const [mensaje, setMensaje] = useState("");
  const [reenviando, setReenviando] = useState(false);
   const [expirado, setExpirado] = useState(false);
  const inputRefs = useRef([]);

  // LÓGICA DE CANAL
  const { canalTexto, destinoTexto } = useMemo(() => {
    const canal = "SMS";
    const destino = celular?.trim() ? celular.trim() : "celular del cliente";

    return { canalTexto: canal, destinoTexto: destino };
  }, [celular]);



  const handleInputChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const nuevoCodigo = [...codigo];
    nuevoCodigo[index] = value;
    setCodigo(nuevoCodigo);

    if (value === "") setMensaje("");

    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  //REENVIAR TOKEN
  const handleReenviarCodigo = async () => {

    if (!celular || !operadorId) {
      setMensaje("Datos incompletos para reenviar el código.");
      return;
    }

    if (reenviando) return;

    setReenviando(true);
    setMensaje("");
    setExpirado(false);

    try {

      await enviarSmsToken({
        operadorId,
        celular,
        correo: correo || ""
      });

      setMensaje(`Se ha reenviado el código por ${canalTexto}.`);
      setCodigo(["", "", "", ""]);

    } catch (error) {
      console.error("Error reenviando token:", error);
      setMensaje("Error del servidor al reenviar código.");
    } finally {
      setReenviando(false);
    }
  };

  //VERIFICAR TOKEN
  const handleVerificarClick = async () => {

    const tokenIngresado = codigo.join("");

    if (tokenIngresado.length !== 4) {
      setMensaje("El código debe tener 4 dígitos.");
      return;
    }

    try {
       const response = await verificarToken({ tokenIngresado });
      const data = response?.data || response;

      if (data.success) {
        setMensaje(data.message || "Token validado correctamente.");
        setExpirado(false);
        onTokenValidado?.(true);
      } else {
        setMensaje(data.message || "Código incorrecto.");

        if (data.message?.toLowerCase().includes("expirado")) {
          setExpirado(true);
        }
      }

    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        "Error al validar el código.";

      setMensaje(backendMessage);

      if (backendMessage?.toLowerCase().includes("expirado")) {
        setExpirado(true);
      }
    }
  };

  const handleCerrarModal = () => {
    setCodigo(["", "", "", ""]);
    setMensaje("");
    onTokenValidado?.(false);
    onClose();
  };

  useEffect(() => {
    if (show) {
      setCodigo(["", "", "", ""]);
      setMensaje("");
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleCerrarModal} centered dialogClassName="modal-pin">
      <Modal.Header closeButton className="justify-content-center">
        <Modal.Title className='titulo-modal-token'>
          Código PIN
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">

        <p style={{ color: '#8f1a95', marginBottom: '20px' }}>
          Ingrese el código de 4 dígitos enviado por{" "}
          <span style={{ color: '#fa4616' }}>{canalTexto}</span>
        </p>

        <div className="d-flex justify-content-center mb-3 gap-2">
          {codigo.map((value, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              className="form-control text-center"
              style={{
                width: '50px',
                height: '50px',
                fontSize: '24px',
                borderRadius: '8px',
                border: '1px solid #ccc',
              }}
              value={value}
              onChange={(e) => handleInputChange(e.target.value, index)}
              ref={(el) => (inputRefs.current[index] = el)}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !codigo[index] && index > 0) {
                  inputRefs.current[index - 1]?.focus();
                }
              }}
            />
          ))}
        </div>

      
        {mensaje && (
          <div
            style={{
              color: mensaje.toLowerCase().includes("correctamente")
                ? "#28a745"
                : "#fa4616",
              fontWeight: "600",
              marginBottom: "16px"
            }}
          >
            {mensaje}
          </div>
        )}

        <p className="mb-1" style={{ fontSize: '14px' }}>
          Estimado asesor, el código fue enviado por{" "}
          <span style={{ color: '#fa4616' }}>{canalTexto}</span>{" "}
          al{" "}
          <span style={{ color: '#fa4616' }}>{destinoTexto}</span>.
        </p>

        <p className="text-muted" style={{ fontSize: '14px' }}>
          En caso no llegue el código intente{" "}
          <span style={{ color: '#8f1a95' }}>solicitar nuevamente</span>.
        </p>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            onClick={handleVerificarClick}
            disabled={expirado}
            style={{
              backgroundColor: expirado ? "#ccc" : "#fa4616",
              borderColor: expirado ? "#ccc" : "#fa4616",
              borderRadius: '24px'
            }}
          >
            Verificar código
          </Button>

          <Button
            variant="outline"
            disabled={reenviando}
            onClick={handleReenviarCodigo}
            style={{
              color: '#8f1a95',
              borderColor: '#8f1a95',
              borderRadius: '24px',
              opacity: reenviando ? 0.6 : 1,
              cursor: reenviando ? 'not-allowed' : 'pointer'
            }}
          >
            {reenviando ? "Enviando..." : "Nuevo código"}
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default ModalToken;
